// Store locator
// - Hides the results count input and defaults it to 3
// - Hides the distance selector and defaults it to 25 Miles
document.addEventListener('DOMContentLoaded', function() {
  const { strings: { store_locator: locales } } = window.theme;

  document.querySelectorAll('#limit').forEach(select => {
    select.innerHTML = `<option selected value="3">3</option>`;
    select.style.display = "none";
  });

  document.querySelectorAll(".search_limit_label").forEach(label => {
    label.style.display = "none";
  });

  document.querySelectorAll('#within_distance').forEach(select => {
    select.value = '25';
    select.disabled = true;
    select.style.display = "none";
  });

  document.querySelectorAll(".distance_label").forEach(label => {
    label.style.display = "none";
  });


  // Replaces default text with translated versions
  const replaceText = () => {
    document.querySelectorAll('.apps__heading').forEach(header => {
      header.innerText = locales.retailers;
    });

    document.querySelectorAll('.main_search_label').forEach(legend => {
      legend.innerText = locales.find_retailers;
    });

    document.querySelectorAll('#address_search').forEach(placeholder => {
      placeholder.placeholder = locales.postal_code;
    });

    document.querySelectorAll('#submitBtn').forEach(button => {
      button.innerText = locales.search;
    });

    document.querySelectorAll('.no_stores_found').forEach(element => {
      element.innerText = locales.no_stores;
    });
  }

  // observe app loading in and call function to replace the text
  new MutationObserver((mutations) => {
    replaceText();
  }).observe(document.querySelector('.apps .search_bar') || document, {
    subtree: false,
    childList: true,
    attributes: true,
  });

  // replace 'get directions' text on search
  new MutationObserver((mutations) => {
    document.querySelectorAll('.directions').forEach(element => {
      element.firstChild.innerText = locales.get_directions;
    });
  }).observe(document.querySelector('#sl_addresses') || document, {
    subtree: false,
    childList: true,
    attributes: true,
  });
});